var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiriLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: ";/",
    width: 614.258,
    height: 25.532,
    viewBox: "0 0 614.258 120.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 86.762,
    height: 120.532,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-242 -427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(4.258 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(237.742 411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M86.744,79.8a37.069,37.069,0,0,0-1.376-11.26c-3.6-12.747-11.21-22.249-23.186-28.115a2,2,0,0,1-1.287-1.839,15.963,15.963,0,0,0-2.515-7.609,17.594,17.594,0,0,0-32.384,6.195A17.579,17.579,0,0,0,42.07,57.807c6.8.46,12.167-2.355,16.012-7.769,1.162-1.637,1.722-1.6,3.194-.755a35.166,35.166,0,0,1-2.29,61.681c-1.1.573-2.242,1.085-3.4,1.547-2.455.985-3.509,3.052-2.718,5.447.688,2.083,3.091,3.13,5.518,2.243a40.622,40.622,0,0,0,11.821-6.618C80.921,104.856,86.351,93.555,86.744,79.8M0,38.311c-.043,7.731.812,12.831,2.684,17.734A42.584,42.584,0,0,0,24.206,79.9,2.64,2.64,0,0,1,25.9,82.187a17.316,17.316,0,0,0,17.778,15.7,17.588,17.588,0,1,0-15.1-27.056c-.926,1.422-1.6,1.476-2.9.662a35.81,35.81,0,0,1-9.754-8.445C8.428,53.27,6.16,42.4,9.808,30.621,13.14,19.863,20.314,12.413,30.774,8.175A4.931,4.931,0,0,0,33.4,6.39a4.3,4.3,0,0,0-.18-4.872C32.044.031,30.106-.34,27.892.5,11.287,6.764.046,23,0,38.311m86.671,1.283a42.533,42.533,0,0,0-8.762-24.788A43.552,43.552,0,0,0,59.015.532a4.722,4.722,0,0,0-4.5.078,3.907,3.907,0,0,0-1.909,3.858,4.2,4.2,0,0,0,3.021,3.643c12.3,4.928,19.7,13.954,22.372,26.9a49.581,49.581,0,0,1,.6,6.449,4.046,4.046,0,0,0,8.072-.242c.02-.54,0-1.081,0-1.622M.052,81.984A39.808,39.808,0,0,0,2.844,95.11a43.554,43.554,0,0,0,12.5,17.523,40.831,40.831,0,0,0,13.289,7.631,3.945,3.945,0,0,0,5.428-4.063c-.1-2.175-1.529-3.19-3.357-3.9a34.589,34.589,0,0,1-16.01-12.489A35.478,35.478,0,0,1,8.135,79.923c-.091-2.847-1.9-4.651-4.417-4.51C1.348,75.547-.07,77.4.048,80.2c.025.594,0,1.19,0,1.785",
    transform: "translate(0 0)",
    fill: "#fdfefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M100.6,91.931c-.393,13.754-5.823,25.055-16.532,33.781a40.637,40.637,0,0,1-11.821,6.618c-2.427.888-4.831-.16-5.518-2.243-.791-2.395.263-4.462,2.718-5.447,1.154-.462,2.293-.974,3.4-1.547a35.166,35.166,0,0,0,2.29-61.681c-1.472-.847-2.031-.882-3.194.755-3.845,5.415-9.213,8.229-16.012,7.769A17.579,17.579,0,0,1,39.849,49.3a17.594,17.594,0,0,1,32.384-6.195,15.963,15.963,0,0,1,2.515,7.609,2,2,0,0,0,1.287,1.839c11.977,5.866,19.591,15.368,23.186,28.115a37.069,37.069,0,0,1,1.376,11.26M47.808,52.39A9.376,9.376,0,0,0,57.174,61.8a9.468,9.468,0,1,0-9.367-9.411",
    transform: "translate(-13.855 -12.13)",
    fill: "#f69b09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M0,38.343C.046,23.033,11.287,6.8,27.892.528c2.214-.836,4.152-.465,5.333,1.022a4.3,4.3,0,0,1,.18,4.872,4.93,4.93,0,0,1-2.631,1.785C20.314,12.444,13.14,19.894,9.808,30.653,6.16,42.432,8.428,53.3,15.924,63.082a35.832,35.832,0,0,0,9.754,8.445c1.3.813,1.972.76,2.9-.663A17.576,17.576,0,1,1,25.9,82.218a2.641,2.641,0,0,0-1.692-2.284A42.582,42.582,0,0,1,2.686,56.076C.815,51.173-.041,46.073,0,38.343m33.96,41.987a9.362,9.362,0,0,0,9.309,9.452,9.434,9.434,0,0,0,.354-18.865,9.333,9.333,0,0,0-9.663,9.413",
    transform: "translate(0 -0.031)",
    fill: "#0990f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M115.006,39.594c0,.541.017,1.082,0,1.622a4.046,4.046,0,0,1-8.072.242,49.581,49.581,0,0,0-.6-6.449c-2.67-12.944-10.072-21.97-22.372-26.9A4.2,4.2,0,0,1,80.94,4.468,3.907,3.907,0,0,1,82.849.61a4.724,4.724,0,0,1,4.5-.078,43.557,43.557,0,0,1,18.9,14.273,42.537,42.537,0,0,1,8.762,24.788",
    transform: "translate(-28.332 0)",
    fill: "#0990f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M.073,122.608c0-.6.021-1.191,0-1.785-.118-2.8,1.3-4.652,3.671-4.785,2.514-.141,4.326,1.662,4.417,4.51a35.478,35.478,0,0,0,6.554,19.892,34.589,34.589,0,0,0,16.01,12.489c1.828.708,3.259,1.723,3.357,3.9a3.945,3.945,0,0,1-5.428,4.063,40.831,40.831,0,0,1-13.289-7.631,43.554,43.554,0,0,1-12.5-17.523A39.808,39.808,0,0,1,.073,122.608",
    transform: "translate(-0.022 -40.624)",
    fill: "#f69b09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M52.244,56.819A9.478,9.478,0,0,1,61.537,47.3a9.467,9.467,0,1,1,.074,18.933,9.376,9.376,0,0,1-9.367-9.411",
    transform: "translate(-18.292 -16.559)",
    fill: "#fdfefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M52.258,118.486a9.333,9.333,0,0,1,9.663-9.413,9.434,9.434,0,0,1-.354,18.865,9.362,9.362,0,0,1-9.309-9.452",
    transform: "translate(-18.296 -38.188)",
    fill: "#fdfefe"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Siri_Technologies",
    "data-name": "Siri Technologies",
    transform: "translate(332 496.5)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fontSize: 70,
    fontFamily: "Leelawadee"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Siri Technologies"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiriLogo);
export default __webpack_public_path__ + "static/media/siri-logo.1f4d7eaba0286aa66fe140e3d6bdb40f.svg";
export { ForwardRef as ReactComponent };